export const CURRENT_TENANT = window.location.hostname.split(".")[0];



// WEBPACK FOOTER //
// ./src/constants/tenant.js